import type { QueryClient } from '@tanstack/svelte-query';
import { getTalksGalleryRestParams } from '../getTalksGalleryRestParams';
import {
	getTalksGalleryBaseParams,
	TALKS_GALLERY_LIMIT,
} from '../talksGalleryPageServerLoad/talksGalleryPageServerLoad';
import {
	getTalksGalleryPage,
	talksGalleryQueryKey,
	type TalksGalleryParams,
} from '#lib/websites/talks/api/getTalksGalleryPage.js';
import type { TalksGalleryPageLoadEvent } from '$routes/talks/gallery/types';

export const TALKS_GALLERY_STALE_TIME = 1000 * 60 * 60;

export const talksGalleryPageLoad = async ({
	parent,
	data,
	url,
	fetch,
}: TalksGalleryPageLoadEvent) => {
	const parentData = await parent();
	const queryClient: QueryClient = parentData.queryClient;
	const filterSections = data.filterSections;
	const talks = data.talks;
	const searchParams = url.searchParams;

	// Seed the cache with the server load's unfiltered first page, under the
	// same key the component's infinite query uses.
	queryClient.setQueryData(
		talksGalleryQueryKey(getTalksGalleryBaseParams(data.currentDate)),
		{
			pageParams: [0],
			pages: [talks],
		}
	);

	const params: TalksGalleryParams = {
		...getTalksGalleryRestParams({
			searchParams,
			filterSections,
			now: data.currentDate,
		}),
		limit: TALKS_GALLERY_LIMIT,
		offset: 0,
	};

	queryClient.prefetchInfiniteQuery({
		queryKey: talksGalleryQueryKey(params),
		queryFn: ({ pageParam }) =>
			getTalksGalleryPage(fetch, { ...params, offset: pageParam as number }),
		initialPageParam: 0,
		staleTime: TALKS_GALLERY_STALE_TIME,
	});

	return {
		...parentData,
		...data,
		params,
	};
};
